import { useEffect } from "react";

const DEFAULT_TITLE = "Hilty, Bower, Haws & Seable, PLLC | Idaho Attorneys at Law";
const DEFAULT_DESC =
  "Hilty, Bower, Haws & Seable, PLLC — Idaho's trusted counsel for more than four decades. Municipal law, estate planning, litigation, business, family, and real estate law.";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSeo({ title, description, path = "/", noindex = false } = {}) {
  useEffect(() => {
    const t = title || DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;
    document.title = t;
    setMeta("name", "description", d);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", `${window.location.origin}${path}`);
    setCanonical(`${window.location.origin}${path}`);
  }, [title, description, path, noindex]);
}
